import { Component, EventEmitter, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CoursesService } from 'src/app/services/courses.service';
import { LocalstorageService } from 'src/app/services/localstorage.service';
import { CertificatesService } from 'src/app/services/certificates.service';
import { Subject, forkJoin, of, switchMap, takeUntil } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { FechaEsPipe } from "../../../shared/interfaces/fecha-es.pipe";

@Component({
    selector: 'app-certificates-card',
    standalone: true,
    templateUrl: './certificates-card.component.html',
    styleUrls: ['./certificates-card.component.scss'],
    imports: [CommonModule, FechaEsPipe]
})
export class CertificatesCardComponent {

  @Output() hasCertificate = new EventEmitter<boolean>();

  hasCertificates:boolean = true;
  idsCursos:any = [];
  pdfUrls: string[] = [];
  validCertificates: { courseId: string, pdfUrl: string }[] | any = [];
  destroy$: Subject<boolean> = new Subject<boolean>();

  constructor(public courses:CoursesService, private localStorage: LocalstorageService, public certificatesService: CertificatesService,
    private route: ActivatedRoute){}

  ngOnInit():void{
    if((this.courses.filteredCourses.length === 0 && !(this.route.snapshot.url[0].path == 'certificados')) || (this.certificatesService.certificates.length === 0 && !(this.route.snapshot.url[0].path == 'certificados'))){
      this.hasCertificates = false;
    }
    if(this.courses.filteredCourses.length === 0 || this.certificatesService.certificates.length === 0){
      this.hasCertificate.emit(false);
    }
    this.loadPdf();
  }

  loadPdf(): void {
    this.courses.courses$.pipe(
      takeUntil(this.destroy$),
      switchMap(courses => {
        const validationObservables = courses.map((course) => {
          const courseId = course.attributes.drupal_internal__nid;
          const nameCourse = course.attributes.title;
          const studentData = this.localStorage.getCurrentUserAsJson();
          const studentId = studentData ? studentData.uid : null;
          return this.certificatesService.validateCertificate(courseId, studentId).pipe(
            switchMap(validation => {
              if (validation && validation.message === 'Se puede generar certificado') {
                const pdfUrl = this.certificatesService.generateCertificate(courseId, studentId);
                this.hasCertificates = true;
                this.hasCertificate.emit(true);
                return of({ courseId, nameCourse, pdfUrl });
              }
              return of(null);
            })
          );
        });
        return forkJoin(validationObservables);
      })
    ).subscribe(
      {
        next: results => {
          this.validCertificates = results.filter(r => r !== null);
          this.certificatesService.certificates = this.validCertificates;
          this.certificatesService.updateCertificates(this.validCertificates);
        },
        error: error => {
          console.error('Error al validar o generar certificados:', error);
        }
      }
    );
  }

  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.complete();
  }

}
